import { useEffect, useState } from "react";
import styled from "styled-components";
import { Menu, FeatureBtn, FeatureText } from "../styles";
import CountUp from "react-countup";
import { userContext } from "../context/userContext";
import { useContext } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../firebase/firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";

const SubscribeBalanceCard = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { currentAccount, subscribeBalance, dispatch } =
    useContext(userContext);
  // const [signalBalance, setSignalBalance] = useState(undefined)
  const { userData, currentPrices } = useContext(userContext);
  const mobile = useMediaQuery("(max-width: 900px)");

  const navigate = useNavigate();

  // useEffect(() => {
  //     onSnapshot(doc(db, "balance", userData.id), (doc) => {
  //       const data = doc.data()
  //       const {signalBalance} = data;
  //       setSignalBalance(signalBalance)
  //     });
  // }, []);

  const [isReveal, setIsReveal] = useState(true);

  function handleReveal(e) {
    e.preventDefault();

    setIsReveal(!isReveal);
  }

  return (
    <Wrapper style={{ maxWidth: !mobile && "360px" }}>
      <div className="left">
        <FeatureBtn>
          <img src="/icons-sidebar/assets.svg" alt="wallet" />
        </FeatureBtn>
        <FeatureText>
          <span className="flex gap-1 items-center">
            <p className="topText smallText font-medium">
              Subscription Balance
            </p>
            <button onClick={handleReveal} className="animate-pulse">
              <img
                src={isReveal ? "/eyes/reveal.svg" : "/eyes/hide.svg"}
                alt="show-password"
                width={13}
              />
            </button>
          </span>
          {isReveal ? (
            <CountUp
              end={subscribeBalance}
              duration={1}
              delay={0}
              separator=","
              prefix="$"
            >
              {({ countUpRef }) => (
                <div>
                  <span className="bottomText bigText" ref={countUpRef} />
                </div>
              )}
            </CountUp>
          ) : (
            <span className="bottomText bigText">*****</span>
          )}
        </FeatureText>
      </div>

      <div className="right">
        <button
          className="switch live"
          onClick={() => navigate("/subscribe-deposit")}
        >
          Deposit
        </button>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 149px;
  padding: 1rem 10px;
  padding-bottom: 1rem;
  border-radius: 10px;
  background: #131824;

  .left {
    display: flex;
    gap: 0.5rem;
  }

  .smallText {
    font-size: 13px;
  }

  .bigText {
    font-size: 20px;
  }

  .right {
    position: relative;

    button {
      cursor: pointer;
    }
  }

  .switchMenu {
    background-color: #1f273a;
    padding: 1rem;
    top: 23px;
    font-weight: 600;
    text-transform: capitalize;
    position: absolute;
    top: 30px;
    right: 0;
    border: 1px solid #19202f;
    cursor: pointer;
  }

  .switch {
    border: none;
    text-transform: capitalize;
    font-weight: 600;
    padding: 0.5rem;
    border-radius: 0.25rem;
    cursor: pointer;
  }

  .practice {
    color: #f7931a;
    background-color: #403529;
  }

  .live {
    color: #20bca4;
    background-color: #20383c;
  }

  .title {
    /* font-size: 1rem; */
  }

  .bigText {
    font-size: 20px;
  }
`;

export default SubscribeBalanceCard;
